<template>
  <manage-reservation class="pt-life-experience-pavilion-reservation__page"></manage-reservation>
</template>

<script>
import ManageReservation from 'cps/appointment-application/pt-life-experience-pavilion-reservation/manage-reservation/index.vue'
export default {
  name: 'manage-reservation__view',
  components: {
    'manage-reservation': ManageReservation
  }
}
</script>
